"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicinalProductIngredient_Strength = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Ratio_1 = require("./RTTI_Ratio");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_MedicinalProductIngredient_ReferenceStrength_1 = require("./RTTI_MedicinalProductIngredient_ReferenceStrength");
exports.RTTI_MedicinalProductIngredient_Strength = t.recursion('IMedicinalProductIngredient_Strength', function () {
    return t.intersection([
        t.type({
            presentation: RTTI_Ratio_1.RTTI_Ratio
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            presentationLowLimit: RTTI_Ratio_1.RTTI_Ratio,
            concentration: RTTI_Ratio_1.RTTI_Ratio,
            concentrationLowLimit: RTTI_Ratio_1.RTTI_Ratio,
            measurementPoint: t.string,
            _measurementPoint: RTTI_Element_1.RTTI_Element,
            country: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            referenceStrength: t.array(RTTI_MedicinalProductIngredient_ReferenceStrength_1.RTTI_MedicinalProductIngredient_ReferenceStrength)
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicinalProductIngredient_Strength.js.map